import { UPLOAD_MEDIA_TYPE } from "../../../../../api/mutations/useUploadMediaMutation";

export const IMAGE_UPLOAD_TYPE = UPLOAD_MEDIA_TYPE.procedureImage;

export const IMAGE_COMPRESS_WIDTH = 1400;
